<template>
  <ion-header :translucent="true">
    <ion-toolbar>
      <ion-buttons slot="secondary">
        <ion-button @click="closeModal">
          <ion-icon slot="icon-only" :icon="closeOutline"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-title>{{ title }}</ion-title>
    </ion-toolbar>
  </ion-header>
  <ion-content fullscreen>
    <ion-list v-if="type == 1">
      <ion-item>
        <ion-label class="ion-text-wrap">
          <p>{{ $t('buttons.blockmessage', { user: user.user_name }) }}</p>
        </ion-label>
      </ion-item>
      <ion-item>
        <ion-label>{{ $t('buttons.block') }} <strong>@{{ this.user.user_name }}</strong></ion-label>
        <ion-toggle @ionChange="changeBlock($event)" value="1" :checked="this.user.status.blocked == 'yes'"
          slot="end"></ion-toggle>
      </ion-item>
      <ion-item>
        <ion-label>{{ $t('buttons.report') }} <strong>@{{ this.user.user_name }}</strong></ion-label>
        <ion-toggle @ionChange="changeReport($event)" value="1" slot="end"></ion-toggle>
      </ion-item>
      <ion-item>
        <ion-textarea rows="2" v-model="reason" :placeholder="$t('placeholder.addcomment')"></ion-textarea>
      </ion-item>
    </ion-list>
    <ion-list v-if="type == 4 || type == 5">
      <ion-item>
        <ion-label class="ion-text-wrap">
          <p>Blocking will cause this user to not be able to join your group. If you have also issued a report, our
            moderation team will review your comments.</p>
        </ion-label>
      </ion-item>
      <ion-item>
        <ion-label>{{ $t('buttons.block') }} <strong>@{{ this.user.user_name }}</strong></ion-label>
      </ion-item>
      <ion-item>
        <ion-textarea rows="2" v-model="reason" :placeholder="$t('placeholder.addcomment')"></ion-textarea>
      </ion-item>
    </ion-list>
    <ion-list v-if="type == 2 || type == 3 || type == 6">
      <ion-item>
        <ion-label class="ion-text-wrap">
          <p>{{ $t('buttons.reportpostmsg') }}</p>
        </ion-label>
      </ion-item>
      <ion-item>
        <ion-checkbox v-model="checkbox1" checked="spam">{{ $t('buttons.spam') }}</ion-checkbox>
      </ion-item>
      <ion-item>
        <ion-checkbox v-model="checkbox2" checked="physical violence" >{{ $t('buttons.violence') }}</ion-checkbox>
      </ion-item>
      <ion-item>
        <ion-checkbox v-model="checkbox3" checked="threat of harm" >{{ $t('buttons.threat') }}</ion-checkbox>
      </ion-item>
      <ion-item>
        <ion-checkbox v-model="checkbox4" checked="porn" >{{ $t('buttons.porn') }}</ion-checkbox>
      </ion-item>
      <ion-item>
        <ion-checkbox v-model="checkbox5" checked="doxxing" >{{ $t('buttons.dox') }}</ion-checkbox>
      </ion-item>
      <ion-item>
        <ion-checkbox v-model="checkbox6" checked="other" >{{ $t('buttons.other') }}</ion-checkbox>
      </ion-item>
      <ion-item>
        <ion-textarea rows="2" v-model="reason" :placeholder="$t('placeholder.addcomment')"></ion-textarea>
      </ion-item>
    </ion-list>
    <ion-button expand="full" @click="sendReport">{{ $t('buttons.submit') }}</ion-button>

  </ion-content>
</template>


<script>
import { IonContent, IonHeader, IonTitle, IonToolbar, IonItem, IonIcon, IonLabel, IonButtons, IonButton, modalController, loadingController, IonCheckbox, IonList, IonTextarea, IonToggle } from '@ionic/vue';
import { closeOutline, bookmarks, people, closeCircle, camera } from 'ionicons/icons';

export default {
  name: 'ReportPost',
  props: {
    title: String,
    imageId: Number,
    user: Object,
    groupId: Number,
    type: Number
  },
  setup() {
    const isDisabled = false;
    const closeModal = () => {
      modalController.dismiss();
    };

    return {
      closeOutline,
      closeModal,
      isDisabled,
      bookmarks,
      people,
      closeCircle,
      camera
    }
  },
  components: { IonContent, IonHeader, IonTitle, IonToolbar, IonItem, IonLabel, IonButtons, IonButton, IonIcon, IonCheckbox, IonList, IonTextarea, IonToggle },
  data() {
    return {
      error: '',
      loadingIndicator: '',
      reason: '',
      checkbox1: false,
      checkbox2: false,
      checkbox3: false,
      checkbox4: false,
      checkbox5: false,
      checkbox6: false,
      reportUser: false,
      blockUser: false
    }
  },
  methods: {
    async sendReport() {
      var reason = this.reason;
      if (this.checkbox1 != false) reason = reason + ' spam';
      if (this.checkbox2 != false) reason = reason + ' physical violence';
      if (this.checkbox3 != false) reason = reason + ' threat of harm';
      if (this.checkbox4 != false) reason = reason + ' porn';
      if (this.checkbox5 != false) reason = reason + ' doxxing';
      if (this.checkbox6 != false) reason = reason + ' other';

      this.presentLoading();

      if (this.type == 2) {
        let response = await this.$store.dispatch("helpers/reportPost", {
          reason: reason,
          id: this.imageId
        });
        if (response) {
          if (response['error'] != null) {
            this.loadingIndicator.dismiss();
            console.log('Error: ' + response['error']);
            console.log(response);
          } else {
            // you can add condition here
            this.loadingIndicator.dismiss();
          }
          modalController.dismiss();
        }
      } else if (this.type == 3) {
        let response = await this.$store.dispatch("helpers/reportComment", {
          reason: reason,
          id: this.imageId
        });
        if (response) {
          if (response['error'] != null) {
            this.loadingIndicator.dismiss();
            console.log('Error: ' + response['error']);
            console.log(response);
          } else {
            // you can add condition here
            this.loadingIndicator.dismiss();
          }
          modalController.dismiss();
        }
      } else if (this.type == 1) {
        var reportFlag = 'no';
        var blockFlag = 'no';
        if (this.blockUser) {
          blockFlag = 'yes';
        }
        if (this.reportUser) {
          reportFlag = 'yes';
        }
        let response = await this.$store.dispatch("helpers/blockUser", {
          friend_id: this.user.id,
          report: reason,
          reportflag: reportFlag,
          blockflag: blockFlag
        });
        if (response) {
          if (response['error'] != null) {
            this.loadingIndicator.dismiss();
            console.log('Error: ' + response['error']);
            console.log(response);
          } else {
            // you can add condition here
            this.loadingIndicator.dismiss();
          }
          modalController.dismiss();
        }
      } else if (this.type == 4) {
        let response = await this.$store.dispatch("groups/removeMember", { id: this.imageId, user_id: this.user.id, block: true, reason: reason });
        if (response) {
          if (response['error'] != null) {
            this.loadingIndicator.dismiss();
            console.log('Error: ' + response['error']);
            console.log(response);
          } else {
            // you can add condition here
            this.loadingIndicator.dismiss();
          }
          modalController.dismiss();
        }
      } else if (this.type == 5) {
        let response = await this.$store.dispatch("groups/deny", { id: this.user.request_id, block: true, reason: reason });
        if (response) {
          if (response['error'] != null) {
            this.loadingIndicator.dismiss();
            console.log('Error: ' + response['error']);
            console.log(response);
          } else {
            // you can add condition here
            this.loadingIndicator.dismiss();
          }
          modalController.dismiss();
        }
      } else if (this.type == 6) {
          let response = await this.$store.dispatch("helpers/reportGroup", {
            reason: reason,
            group_id: this.groupId
          });
          if (response) {
            if (response['error'] != null) {
              this.loadingIndicator.dismiss();
              console.log('Error: ' + response['error']);
              console.log(response);
            } else {
              // you can add condition here
              this.loadingIndicator.dismiss();
            }
            modalController.dismiss();
          }
      }
    },
    changeReport(ev) {
      console.log(ev.target.checked);
      this.reportUser = ev.target.checked;
    },
    changeBlock(ev) {
      console.log(ev.target.checked);
      this.blockUser = ev.target.checked;
    },
    async presentLoading() {
      this.loadingIndicator = await loadingController
        .create({
          cssClass: 'loading-class',
          message: this.$t('loadmessage.sendreport'),
        });
      await this.loadingIndicator.present();
    },
  },
}
</script>
